<template>
    <el-dialog :title="title" :visible.sync="visible" @close="onCance(false)" customClass="customWidth" v-dialogDrag>
      <el-form ref="baseForm" label-width="120px" class="dialog-from flex" :rules="rules" :model="resourceForm">
        <el-form-item class="item" label="客户等级：" prop="customerLevel">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.customerLevel"></el-input>
        </el-form-item>

        <el-form-item class="item" label="销售组织编码：" prop="saleOrgCode">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.saleOrgCode"></el-input>
        </el-form-item>

        <el-form-item class="item" label="销售组织描述：" prop="saleOrgDesc">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.saleOrgDesc"></el-input>
        </el-form-item>

        <el-form-item class="item" label="客户组织：" prop="customeGroup">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.customeGroup"></el-input>
        </el-form-item>

        <el-form-item class="item" label="销售区域：" prop="saleArea">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.saleArea"></el-input>
        </el-form-item>

        <el-form-item class="item" label="价格组(客户)：" prop="priceGroup">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.priceGroup"></el-input>
        </el-form-item>

        <el-form-item class="item" label="销售组描述：" prop="saleGroupDesc">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.saleGroupDesc"></el-input>
        </el-form-item>

        <el-form-item class="item" label="销售部门：" prop="saleDepartment">
          <el-input type="text" placeholder="请输入" v-model="resourceForm.saleDepartment"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCance(false)">取 消</el-button>
        <el-button type="primary" @click.stop="onSubmitResource" v-loading="$store.state.isLoading">确 定</el-button>
      </div>
  </el-dialog>
</template>

<script>
export default {
   props:{
      title:{
        type:String,
        default(){
           return 'window title'
        }
      },
      isEditOperate:{
         type:Boolean,
         default(){
           return false;
         }
      },
      parentResources:{
        type:Array,
        default(){
          return []
        }
      },
      // resourceTypes:{
      //   Type:Array,
      //   default(){
      //     return [
      //     {"label":"主模块","value":1},
      //     {"label":"子模块","value":2},
      //     {"label":"菜单","value":3},
      //     {"label":"功能","value":4},
      //   ]}
      // },
      selectedResource:{
        Type:Object,
        default(){ 
          return []
        }
      }
    },
    watch:{
        
    },
    data(){
      return {
        resourceForm:{
          isEdit:false,//状态
        },
        visible:false,    
        rules:{
          
        },
      }
    },
    methods:{
      created(){
      },
      onCance(visible){
        let vm=this;
        vm.visible=visible;
        vm.$emit("onCance",visible);
        vm.resetForm();
      },
      // onChangeType(selectedValue){
      //    this.resourceForm["resourceType"]=selectedValue;
      // },
      onChangeParent(){

      },
      showWindow(show){
        this.visible=show;
      },
      /**
       * 重置表单
       */
      resetForm(){
         this.resourceForm={};
      },
      /**
       * 提交资源
       */
      onSubmitResource(){
        let vm = this;       
        vm.$refs['resourceForm'].validate(async (vaild)=>{
          if(vaild){
             vm.$emit('onSubModifyResource',vm.resourceForm);
          }                     
        });
      }
    }
}
</script>